import { LOGO_SRC } from "../logoDisplay";

export default function EarnixLogo({ size = 44, glow = false }) {
  return (
    <img
      src={LOGO_SRC}
      alt="Earnix Global"
      width={size}
      height={size}
      decoding="sync"
      style={{
        width: size,
        height: size,
        objectFit: "contain",
        display: "block",
        flexShrink: 0,
        filter: glow ? "drop-shadow(0 0 14px rgba(255,184,0,0.8))" : "none",
      }}
    />
  );
}

/* ── Wordmark ── */
export function EarnixWordmark({ size = 1, dark = false }) {
  return (
    <div style={{ lineHeight: 1, userSelect: "none" }}>
      <div style={{
        fontFamily: "'Figtree', -apple-system, sans-serif",
        fontWeight: 800,
        fontSize: 18 * size,
        background: "linear-gradient(135deg, #FFE875 0%, #FFB800 50%, #C8860A 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        letterSpacing: 3,
        lineHeight: 1,
      }}>EARNIX</div>
      <div style={{
        fontFamily: "'Figtree', -apple-system, sans-serif",
        fontWeight: 400,
        fontSize: 7 * size,
        color: dark ? "rgba(160,110,0,0.8)" : "rgba(255,184,0,0.85)",
        letterSpacing: 6,
        lineHeight: 1.8,
        textTransform: "uppercase",
      }}>Global</div>
    </div>
  );
}
